/**
 * A chave-mestra do administrador (era o "Ver tudo", e era também do designer): as fórmulas de
 * acesso das coleções deixam de valer para ele, que precisa ver o que elas escondem para avaliá-las e
 * para consertar dados (decisão do usuário). Por ambiente. O nome interno, `seeAll`, ficou: é
 * contrato com o servidor.
 *
 * **Guardada neste navegador**, e não no servidor: é conveniência de quem olha, e não estado do
 * ambiente. Quem garante é o servidor — ele só aceita o pedido do administrador, e de qualquer outro
 * o ignora; daqui sai só o pedido.
 *
 * Leitura e escrita protegidas: num navegador sem armazenamento (privado, bloqueado), a chave
 * simplesmente não lembra, e tudo funciona desligado.
 */

const KEY = 'ontos.seeAll'

/** O cabeçalho do pedido — o `SEE_ALL_HEADER` do servidor. */
export const SEE_ALL_HEADER = 'X-Lunedi-See-All'

function stored(): string[] {
    try {
        return JSON.parse(localStorage.getItem(KEY) || '[]')
    } catch (err) {
        return []
    }
}

/** A chave-mestra está ligada neste ambiente? */
export function seeingAll(systemAlias: string): boolean {
    return stored().includes(systemAlias)
}

export function setSeeingAll(systemAlias: string, on: boolean) {
    const others = stored().filter(alias => alias !== systemAlias)
    try {
        localStorage.setItem(KEY, JSON.stringify(on ? [...others, systemAlias] : others))
    } catch (err) {
        //Sem armazenamento, a chave não lembra — e o pedido sai desligado
    }
}

/**
 * O ambiente de uma requisição, pelo próprio endereço (`systems/:alias/...`) — e não por um "ambiente
 * atual" guardado à parte: a requisição diz de onde é.
 */
export function systemOfUrl(url: string | undefined): string | undefined {
    const match = /^\/?systems\/([^/?]+)/.exec(url || '')
    return match ? decodeURIComponent(match[1]) : undefined
}
